// not deleting until happy v2 is working - allows for quick reversal
// export { default } from '@/components/DealsPage';

/* eslint-disable react/jsx-props-no-spreading */
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
// eslint-disable-next-line no-use-before-define
import React from 'react';
import { useRouter } from 'next/router';

import { logger } from '@shared/utils';

import { Meta } from '@/v2/components/global/Meta';
import { CampaignView } from '@/v2/components/pages/CampaignView';
import { LoadingView } from '@/v2/components/pages/LoadingView';
import { getCampaignPage } from '@/v2/services/bff/getCampaignPage';
import { getCampaigns } from '@/v2/services/sanity/api/campaign';

export const getStaticPaths = async () => {
  const campaigns = await getCampaigns({ preview: false });

  const paths = campaigns
    .filter(({ slug }) => slug !== 'last-minute')
    .map(({ slug }) => ({ params: { campaignSlug: slug } }));

  return {
    paths: [...paths],
    fallback: 'blocking',
  };
};

export const getStaticProps = async ({
  preview,
  params,
}: GetStaticPropsContext<{ campaignSlug: string }>) => {
  try {
    const props = await getCampaignPage({
      preview,
      slug: params?.campaignSlug,
    });

    return {
      props,
      // set static deals page regeneration -> 120 seconds;
      revalidate: 120,
    };
  } catch (error) {
    logger.error(error);
    return {
      props: {} as Awaited<ReturnType<typeof getCampaignPage>>,
      revalidate: 120,
      redirect: {
        destination: '/deals',
      },
    };
  }
};

const CampaignPage = ({
  meta,
  campaign,
  destinations,
  tiles,
  importantInformation,
  navigation,
  warningMessage,
  informationMessage,
  marketingMessage,
  campaigns,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const router = useRouter();

  if (router.isFallback) {
    return <LoadingView />;
  }

  return (
    <>
      <Meta {...meta} />
      <CampaignView
        campaign={campaign}
        campaigns={campaigns}
        destinations={destinations}
        tiles={tiles}
        importantInformation={importantInformation}
        navigation={navigation}
        informationMessage={informationMessage}
        warningMessage={warningMessage}
        marketingMessage={marketingMessage}
      />
    </>
  );
};

export default CampaignPage;
